import { NEW, TEST, RETURNED, ACTIVE, OBSOLETE } from 'utils/constants'
import { displayModuleName } from 'i18n/displayConstants'
import strings from 'utils/strings.js'

const confirmModuleLockIn = (moduleName, status, revision) => {
  // Don't show modal if status is not NEW, or if it's a revision
  if (status !== NEW || (revision && revision !== '-')) return null

  const modName = displayModuleName(moduleName)

  return {
    header: strings.keep_as_module(modName),
    yesButtonText: strings.to_test,
    message: strings.lock_in_module_module_name(modName),
  }
}

export default function (moduleName, status, revision) {
  const prompt = confirmModuleLockIn(moduleName, status, revision)

  return {
    [NEW]: {
      promoteAction: {
        prompt,
        changeStatusTo: TEST,
      },
    },
    [TEST]: {
      promoteAction: {
        prompt,
        changeStatusTo: ACTIVE,
      },
      regressAction: {
        changeStatusTo: RETURNED,
      },
    },
    [RETURNED]: {
      promoteAction: {
        changeStatusTo: TEST,
      },
    },
    [OBSOLETE]: {},
    [ACTIVE]: {},
  }[status]
}
